import React, { useState, useEffect } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
// import PositionImageViewModal from './viewImageModal';

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ItemPageContainer from "layouts/itemPageContainer";

import CardItem from "components/alove/CardItem";
import { avatarUrl, camelCaseToCapitalizedWords, formatDate } from "utils/globalsUtils";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";
import { getByUserId } from "utils/enduserUtils";
import { EndUser } from "models/profile/EndUser";
import { useMaterialUIController } from "context";
import { Profile, ProfileAsset, ProfileStatus } from "models/profile/Profile";

const MDInput = require("components/MDInput/index.js").default;
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AttrDisplay } from "./components/display";
import { getAttribute, updateAttributeDO } from "utils/attributesUtil";
import { Attribute } from "models/profile/Attribute";
import { AttrResponses } from "./components/responses";
import { Prevalidate } from "layouts/questionnaire/question/component/prevalidate";
import { RelatedAttributes } from "./components/relatedAttribute";
import { AttributeSettings } from "./components/attributeSettings";
import { PreValidation } from "models/batch/PreValidation";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;
const MDSnackbar = require("components/MDSnackbar/index.js").default;
import { PageNumber } from "../../../accessNumbers";
let newStatus = ProfileStatus.Active;

function ViewAttribute() {
  const pageNumber = PageNumber.ViewAttribute;
  const [controller, dispatch] = useMaterialUIController();
  const { currentLanguage } = controller;
  const isAdmin = true;
  const [inputErrors, setInputErrors] = useState({});

  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);

  const [attribute, setAttribute] = useState<Attribute>({} as Attribute);

  let { id } = useParams();

  const [queryParameters] = useSearchParams();
  const [filter, setFilter] = useState(queryParameters.get("filter") || "");

  useEffect(() => {
    if (id) {
      getAttribute(id!).then((res) => {
        setLoader(false);
        setAttribute(Object.assign(new Attribute(), res));
      });
    }
  }, [id,currentLanguage]);


  const  _setAttribute = async(attr) => {
    setAttribute(attr);
    await updateAttributeDO(attr);
  };


  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={attribute?.txt} />
      <ItemPageContainer
        loader={loader}
        navItems={[
          { label: "Attribute" },
          { label: "Display Settings", ref: "display" },
          { label: "Responses", ref: "responses" },
          { label: "Pre-validate", ref: "pre-validate" },
          { label: "Related Attributes", ref: "related-attributes" },
        ]}
        actions={{
          itemName: `Attribute`,
          itemNumber: `ID: ${id}`,
          actionsTitle: "Attribute Actions",
          actions: [],
        }}
      >
        <CardItem title="Display Settings" id="display">
          <AttrDisplay attribute={attribute} setAttribute={_setAttribute} />
        </CardItem>
        <CardItem title="Related Question" id="responses" addButton="Question" addNewContact={() => navigate(`/questions/${attribute.editingQuestionId}`)}>
          <AttrResponses attribute={attribute!} setAttribute={_setAttribute} />
        </CardItem>

        <CardItem title="Pre-validate" id="pre-validate" defaultClosed>
          <Prevalidate preValidation={attribute.preValidation} updatePrevalidation={(preValidation: PreValidation[]) => 
            _setAttribute({...attribute, preValidation})
          }/>
          </CardItem>

          <CardItem title="Related Attribute" id="related-attributes" defaultClosed>
            <RelatedAttributes responses={attribute.responses} attrName={attribute.name} />
          </CardItem>

          <CardItem title="Attribute Settings" id="attribute-settings" defaultClosed>
            <AttributeSettings attribute={attribute} setAttribute={_setAttribute} />
          </CardItem>
      </ItemPageContainer>
    </DashboardLayout>
  );
}

export default ViewAttribute;
